import { connect } from 'react-redux';
import { compose } from 'redux';

import { withRouter } from 'src/router/utils';
import { getCurrentRepositoryFullSlug } from 'src/selectors/repository-selectors';
import urls from 'src/urls/source';

import SelectedLineProvider from '../components/selected-line-provider';

// @ts-ignore TODO: fix noImplicitAny error here
const mapStateToProps = (state, ownProps) => {
  const repositoryFullSlug = getCurrentRepositoryFullSlug(state);

  // Force the URL to use the full HEAD commit hash when on a branch for better shared links
  // Otherwise, if the URL is used after updates are made to the file on the original branch,
  // the referenced line numbers might be incorrect
  const { hash } = state.repository.source.section;

  const targetUrl = repositoryFullSlug
    ? urls.ui.source(repositoryFullSlug, {
        refOrHash: hash,
        path: ownProps.path,
      })
    : null;

  return { targetUrl };
};

export default compose(
  withRouter,
  connect(mapStateToProps)
)(SelectedLineProvider);
